// @ts-ignore
import UAParser from '@amplitude/ua-parser-js';
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

import type { HydrateAction } from 'redux-store/index';

import type { TUiModalTypes, IUIAppTypes } from './types';

const initialState: IUIAppTypes = {
  isOpenModal: false,
  modalType: '',
  //stringify → parse to remove undefined from object
  userAgent: JSON.parse(JSON.stringify(UAParser(''))),
  isTopBannerShowed: true,
  referer: '',
  region: '',
  country: '',
  ipAddress: '',
  redirectUrl: '',
  showCookieBanner: false,
  locale: 'en',
};
const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    openModal(
      state,
      action: PayloadAction<{ type: TUiModalTypes; redirectUrl?: string }>,
    ) {
      state.isOpenModal = true;
      state.modalType = action.payload.type;
      state.redirectUrl = action.payload.redirectUrl;
    },
    closeModal(state) {
      state.isOpenModal = false;
      state.modalType = '';
      state.redirectUrl = '';
    },
    setUserAgent(state, action: PayloadAction<string | undefined>) {
      //stringify → parse to remove undefined from object
      state.userAgent = JSON.parse(JSON.stringify(UAParser(action.payload)));
    },
    setLocale(state, action: PayloadAction<'en' | 'ru'>) {
      state.locale = action.payload;
    },
    setTopBannerShowed(
      state,
      action: PayloadAction<Record<string, string | boolean | undefined>>,
    ) {
      state.isTopBannerShowed =
        action.payload.isTopBannerShowed === 'true' ||
        action.payload.isTopBannerShowed === undefined;
    },
    setReferer(state, action: PayloadAction<string>) {
      state.referer = action.payload;
    },
    setRegion(state, action: PayloadAction<string | undefined>) {
      state.region = action.payload || '';
    },
    setCountry(state, action: PayloadAction<string | undefined>) {
      state.country = action.payload || '';
    },
    setIpAddress(state, action: PayloadAction<string | undefined>) {
      state.ipAddress = action.payload || '';
    },
    setCookieBannerVisible(state, action: PayloadAction<boolean>) {
      state.showCookieBanner = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: HydrateAction<IUIAppTypes>) => {
      return action.payload.ui;
    });
  },
});

export const {
  openModal,
  closeModal,
  setUserAgent,
  setTopBannerShowed,
  setLocale,
  setReferer,
  setRegion,
  setCountry,
  setIpAddress,
} = uiSlice.actions;

export default uiSlice.reducer;
